import React from 'react';

const Col = ({ children, w = 12 }) => (
  <div className={`col-md-${w}`}>{children}</div>
);

export default Col;
